import { Alignment, Direction, Displaying, dontForwardTheseProps, Spacing, Typography } from "@bonusx-global/bx-design-system";
import styled from "@emotion/styled";
import Box from "@mui/material/Box";
import { memo } from "react";
import useIsMobile from "../../../../../hooks/device/useIsMobile";
import type { IWithIsMobile } from "../../../../interfaces/IWithIsMobile.interface";
import Spacer from "../../../common/Spacer";
import { AiChatbotIconContainer } from "../ai-chatbot-icon-container/ai-chatbot-icon-container";
import { AiChatbotIcon } from "../ai-chatbot-icon/ai-chatbot-icon";

const EmptyStateContainer = styled(Box, { shouldForwardProp: dontForwardTheseProps(["isMobile"]) })<IWithIsMobile>(({ isMobile }) => ({
  flexGrow: 1,
  display: Displaying.flex,
  flexDirection: Direction.column,
  justifyContent: Alignment.start,
  alignItems: Alignment.center,
  padding: isMobile ? `${Spacing[1000]} ${Spacing[750]}` : `${Spacing[2000]} ${Spacing[1500]}`,
}));

export const CHATBOT_EMPTY_STATE_ID = "chatbot-empty-state";

function ChatbotEmptyState(): JSX.Element {
  const isMobile = useIsMobile();
  const spacingValue = isMobile ? "1000" : "1500";

  return (
    <EmptyStateContainer isMobile={isMobile} id={CHATBOT_EMPTY_STATE_ID}>
      <AiChatbotIconContainer>
        <AiChatbotIcon animated={false} />
      </AiChatbotIconContainer>

      <Spacer spacingValue={spacingValue} />

      <Typography variant="body1" color="textSecondary">
        Come posso aiutarti?
      </Typography>
    </EmptyStateContainer>
  );
}

export default memo(ChatbotEmptyState);
